/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_S1Inputs */

const en_tut_wb_s1 = /** @type {(inputs: Tut_Wb_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From a meeting, a document, or an area card in the office, press the whiteboard button, then **Buat papan tulis** if there isn't one yet.`)
};

const id_tut_wb_s1 = /** @type {(inputs: Tut_Wb_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari halaman rapat, dokumen, atau kartu area di kantor, tekan tombol papan tulis lalu **Buat papan tulis** kalau belum ada.`)
};

/**
* | output |
* | --- |
* | "From a meeting, a document, or an area card in the office, press the whiteboard button, then **Buat papan tulis** if there isn't one yet." |
*
* @param {Tut_Wb_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_s1 = /** @type {((inputs?: Tut_Wb_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_s1(inputs)
	return en_tut_wb_s1(inputs)
});